import { IHttpApi } from '@cian/http-api/shared';

import { isResponseContainsKey } from './helpers';
import { ILogger } from '@cian/logger';
import { IGetVillageListRequestSchema } from '../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';
import {
  fetchGetVillageList,
  TGetVillageListResponse,
} from '../../node/repositories/countryside-search/v1/get-village-list';
import { IGetVillageListResponseSchema } from '../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IErrorResponseSchema } from '../repositories/countryside-search/entities/schemas/ErrorResponseSchema';

export async function getVillageList(httpApi: IHttpApi, logger: ILogger, parameters: IGetVillageListRequestSchema) {
  try {
    const { response } = await fetchGetVillageList<TGetVillageListResponse, TGetVillageListResponse>({
      httpApi,
      parameters,
    });

    if (isResponseContainsKey<IErrorResponseSchema, IGetVillageListResponseSchema>(response, 'errors')) {
      throw response;
    }

    return response;
  } catch (error) {
    logger.error(error, { message: 'Error in getVillageList' });
    throw error;
  }
}
